module.exports = __webpack_public_path__ + "img/thingstotry_lg.4cc3c9f2.png";